<div class="background identity-splash-screen d-flex fd-row jc-center ai-center">

    <img class="background-left-image" src="../../../../../../assets/public/left-background.png">
    <img class="background-right-image" src="../../../../../../assets/public/bottom-right-aligned-background.png">


    <div class="identity-card card d-flex fd-col ai-stretch">
        <lib-verify-email-confirmation></lib-verify-email-confirmation>
    </div>
</div>